module.exports = __webpack_public_path__ + "static/img/statics.bec668b9.png";